import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map, of, tap } from 'rxjs';

import { OFFER_SERVER_URL } from '../../config';
import { TranslationService } from '../../shared/services/translation.service';
import { CodeValue } from '../../shared/models/code-value';

import { ProductTranslationService } from './product-translation.service';

const FIELD_NAMES_URL = `${ OFFER_SERVER_URL }/products:fields`;

@Injectable({ providedIn: 'root' })
export class ProductService {
	private configurationFieldNamesLoaded = false;
	constructor(
		private readonly http: HttpClient,
		private readonly productTranslationService: ProductTranslationService,

		private readonly snackBar: MatSnackBar,
		private readonly translationService: TranslationService
	) {}

	showMessage(msg: string) {
		this.snackBar.open(
			msg,
			undefined,
			{ duration: 5000 }
		);
	}

	showError(msg?: string) {
		this.snackBar.open(
			msg === undefined
				? this.translationService.getTR('quapp.error')
				: `${ this.translationService.getTR('quapp.error') } - ${ msg }`,
			undefined,
			{ duration: 5000 }
		);
	}

	loadConfigurationFieldNames() {
		if (this.configurationFieldNamesLoaded) {
			return of(false);
		}
		return this.loadFieldNameTranslations(false).pipe(tap(
			() => {
				this.configurationFieldNamesLoaded = true;
			}
		));
	}

	loadFieldNameTranslations(
		a2c: boolean
	) {
		const url = new URL(FIELD_NAMES_URL);
		const params = url.searchParams;
		params.append('a2c', String(a2c));
		return this.http.get<CodeValue[]>(url.toString())
			.pipe(
				tap(fieldNameTranslations => {
					this.productTranslationService.add(fieldNameTranslations);
				}),
				map(() => true)
			);
	}
}
